export function validate(values) {
    let errors = {};

    if(!values.confirmText){
      errors.confirmText = 'You must confirm and follow the HOS Regulations.'
    }
    return errors;
}
